import React, {ChangeEvent, ReactElement, useEffect, useState} from 'react';
import {cx} from '@emotion/css';
import {FormattedMessage, useIntl} from 'react-intl';
import styles from './LanguageBanner.styles';
import {Locale} from '../LocaleContext';
import Select from '../../components/DesignSystem/Fields/Select/Select';
import {UPDATE_LANG_EVENT} from '../../constants';
import {Option} from '../../components/DesignSystem/Fields/types';

interface LanguageBannerProps {
  lang: Locale;
  className?: string;
}

function LanguageBanner({lang, className}: LanguageBannerProps): ReactElement | null {
  const {formatMessage} = useIntl();
  const [selectedLanguage, setLang] = useState<Locale>(lang)

  useEffect(() => {
    setLang(lang);
  }, [lang]);

  const changeHandler = (ev: ChangeEvent<HTMLSelectElement>) => {
    const newLang = ev.target.value as Locale;
    window.dispatchEvent(new CustomEvent(UPDATE_LANG_EVENT, {detail: newLang}));
  };

  const languageOptions: Option[] = [
    {
      label: formatMessage({id: 'displayLanguage.options.en-GB'}),
      value: Locale.uk,
    },
    {
      label: formatMessage({id: 'displayLanguage.options.nl'}),
      value: Locale.nl,
    },
    {
      label: formatMessage({id: 'displayLanguage.options.test'}),
      value: Locale.test,
    },
  ];

  return selectedLanguage ? (
    <div className={cx(styles.container, className)}>
      <div className={cx(styles.label)}><FormattedMessage id="languageBanner.description" /></div>
      <Select label="" name="language" value={selectedLanguage} onChange={changeHandler} options={languageOptions} />
    </div>
  ): null;
}

export default LanguageBanner;
